import api from './api';

const appointmentService = {
  // Get all appointments
  getAppointments: async () => {
    try {
      const response = await api.get('/appointments');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },
  
  // Create appointment
  createAppointment: async (appointmentData) => {
    try {
      const response = await api.post('/appointments', appointmentData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating appointment:', error);
      throw error;
    }
  },
  
  // Get appointment by ID
  getAppointment: async (id) => {
    try {
      const response = await api.get(`/appointments/${id}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching appointment ${id}:`, error);
      throw error;
    }
  },
  
  // Update appointment
  updateAppointment: async (id, appointmentData) => {
    try {
      // Special handling for status-only updates
      if (appointmentData.status && Object.keys(appointmentData).length === 1) {
        // Just update the status - use a direct API call for this special case
        const response = await api.post(`/appointments/${id}/status`, { status: appointmentData.status });
        return response.data.data;
      }
      
      // For regular updates that include all fields
      const response = await api.put(`/appointments/${id}`, appointmentData);
      return response.data.data;
    } catch (error) {
      // More detailed error logging
      console.error(`Error updating appointment ${id}:`, error);
      console.error('Request payload:', appointmentData);
      if (error.response) {
        console.error('Server response:', error.response.data);
      }
      throw error;
    }
  },
  
  // Delete appointment
  deleteAppointment: async (id) => {
    try {
      // Rely on the interceptor for CSRF token
      const response = await api.delete(`/appointments/${id}`);
      return response.data;
    } catch (error) {
      // More detailed error logging
      console.error(`Error deleting appointment ${id}:`, error);
      if (error.response) {
        console.error('Server response:', error.response.data);
      }
      throw error;
    }
  },

  // Send appointment to CRM (same Zapier pattern as customers/assessments;
  // requires the backend to expose POST /zapier/send-appointment)
  sendToCrm: async (appointmentId) => {
    if (!appointmentId) throw new Error('Appointment ID required for CRM sync');
    try {
      const response = await api.post('/zapier/send-appointment', { appointmentId });
      return response.data;
    } catch (error) {
      console.error(`Error sending appointment ${appointmentId} to CRM:`, error);
      throw error;
    }
  },
};

export default appointmentService;